import { useState } from "react";
import { Instagram, MapPin, Mail, Clock } from "lucide-react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "General", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Thank you — we'll be in touch shortly.");
      setForm({ name: "", email: "", phone: "", subject: "General", message: "" });
    } catch { toast.error("Please try again"); } finally { setLoading(false); }
  };

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16" data-testid="contact-page">
      <div className="border-b divider-gold pb-10">
        <div className="overline text-emerald mb-3">Say hello</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight">Get in touch</h1>
        <p className="mt-4 max-w-lg text-charcoal/60">Commissions, press, or just a note about the linen wrap — we read every message ourselves.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mt-16">
        <form onSubmit={submit} className="space-y-5">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="overline text-charcoal/60 mb-2 block">Name</label>
              <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" className="bg-transparent border-0 border-b divider-gold rounded-none focus-visible:ring-0 py-3" />
            </div>
            <div>
              <label className="overline text-charcoal/60 mb-2 block">Email</label>
              <Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" className="bg-transparent border-0 border-b divider-gold rounded-none focus-visible:ring-0 py-3" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="overline text-charcoal/60 mb-2 block">Phone (optional)</label>
              <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone" className="bg-transparent border-0 border-b divider-gold rounded-none focus-visible:ring-0 py-3" />
            </div>
            <div>
              <label className="overline text-charcoal/60 mb-2 block">Subject</label>
              <Input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} data-testid="contact-subject" className="bg-transparent border-0 border-b divider-gold rounded-none focus-visible:ring-0 py-3" />
            </div>
          </div>
          <div>
            <label className="overline text-charcoal/60 mb-2 block">Message</label>
            <Textarea required rows={7} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" className="bg-transparent border divider-gold rounded-none focus-visible:ring-0" />
          </div>
          <Button data-testid="contact-submit" disabled={loading} type="submit" className="rounded-none bg-emerald hover:bg-emerald/90 text-ivory tracking-[0.15em] uppercase text-xs px-8 py-6">
            {loading ? "Sending…" : "Send message"}
          </Button>
        </form>

        <div className="space-y-10">
          <div className="aspect-[4/3] bg-ivory relative overflow-hidden">
            <iframe
              title="Warispura, Kamptee — studio location"
              src="https://www.openstreetmap.org/export/embed.html?bbox=79.1759%2C21.2098%2C79.1959%2C21.2298&layer=mapnik&marker=21.2198%2C79.1909"
              className="w-full h-full border-0"
              loading="lazy"
              data-testid="contact-map"
            />
            <a
              href="https://www.google.com/maps?q=21.2198,79.1909"
              target="_blank"
              rel="noopener noreferrer"
              className="absolute bottom-3 right-3 bg-ivory/95 text-charcoal text-xs px-3 py-1.5 shadow-sm hover:bg-ivory"
            >
              Open in Google Maps
            </a>
          </div>
          <div className="grid grid-cols-1 gap-6 text-sm">
            <div className="flex items-start gap-4"><MapPin className="w-5 h-5 text-emerald mt-0.5" /><div><div className="overline text-charcoal/60 mb-1">Address</div>Warispura, kamptee, Nagpur</div></div>
            <div className="flex items-start gap-4"><Mail className="w-5 h-5 text-emerald mt-0.5" /><div><div className="overline text-charcoal/60 mb-1">Email</div>fatemarida101@gmail.com</div></div>
            <div className="flex items-start gap-4"><Clock className="w-5 h-5 text-emerald mt-0.5" /><div><div className="overline text-charcoal/60 mb-1">Hours</div>Tue – Sat · 10am – 6pm</div></div>
            <a href="https://ig.me/m/_crystal_clear_crafts_" target="_blank" rel="noopener noreferrer" data-testid="instagram-dm-btn" className="mt-2 inline-flex items-center gap-3 bg-emerald text-ivory px-6 py-3 hover:bg-emerald/90 w-fit tracking-[0.15em] uppercase text-xs">
              <Instagram className="w-4 h-4" /> Instagram DM
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
